<template lang="pug">
  - $image_path = '@/assets/images/sound/';
  .page-welcome
    p.text: img(src=`${$image_path}text.png` alt="このサイトでは音声が流れますONにしてお楽しみください")
    .sound
      button.sound-button(@click="setIsMute(false)"): img(src=`${$image_path}button_on.png` alt="ON")
      button.sound-button(@click="setIsMute(true)"): img(src=`${$image_path}button_off.png` alt="OFF")
    p.guide: img(src=`${$image_path}text_guide.png` alt="このゲームは、画面をタテにして遊んでね！")
</template>

<script>
import CookieData from '@/assets/js/CookieData';
import SoundController from '@/assets/js/SoundController';

export default {
  name: 'Welcome',
  methods: {
    setIsMute(isMute) {
      CookieData.setIsMute(isMute);
      SoundController.mute(CookieData.isMute);
      SoundController.play('se_click_button');
      this.$router.push({ name: 'top' });
    }
  }
};
</script>

<style scoped lang="scss">
.page-welcome {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 100%;
  background: image-url('common/bg_castle_hardthin.png') no-repeat
    map-get($primary_color, 'hard_thin_grass');
  background-size: 100% auto;
  .text {
    margin: vw(430) auto 0;
    width: vw(893);
  }
  .sound {
    display: flex;
    justify-content: space-between;
    width: vw(1176);
    margin: vw(265) auto 0;
    &-button {
      display: block;
      width: vw(576);
    }
  }
  .guide {
    margin-top: vw(88);
    margin-left: vw(3);
    width: vw(1245);
  }
}
</style>
